

























import { Component, Watch, Prop } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import PlanLimitsMixin from '@/components/ui/mixins/plan-limits-mixin';

@Component
export default class BotFilterMarks extends mixins(PlanLimitsMixin) {
  @Prop() conditions: any;
  value: string = 'IS_NOT_BOT';
  predicate: string = 'EQUALS';

  @Watch('conditions', {
    immediate: true
  })
  onConditionsChanged(value: any, oldValue: any) {
    if(!value.botMark) {
      this.$set(this.conditions, 'botMark', {
        predicate: 'EQUALS',
        values: 'IS_NOT_BOT'
      });
    }
  }

  @Watch('value')
  onValueChanged(value: string, oldValue: string) {
    this.$set(this.conditions.botMark, 'values', value);
  }

  @Watch('predicate')
  onPredicateChanged(value: string, oldValue: string) {
    this.$set(this.conditions.botMark, 'predicate', value);
  }

  mounted() {
    this.value = this.conditions.botMark.values;
  }

  // updated() {
  //   this.conditions.botMark = {};
  //   this.conditions.botMark.values = this.value;
  //   this.conditions.botMark.predicate = this.predicate;
  //   // console.log('BIND TO FORM >>> bot filter', this.conditions);
  // }
}
